/**
 * Hook personalizado para manejar reCAPTCHA v3
 */
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { validateRecaptcha } from '../services/surveyService';

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  /**
   * Ejecuta y valida reCAPTCHA
   * @param {string} action - Acción a ejecutar (ej: 'submit_survey')
   * @param {number} minScore - Puntuación mínima requerida
   * @returns {Promise<{success: boolean, token?: string, error?: string}>}
   */
  const executeAndValidate = async (action = 'submit_survey', minScore = 0.5) => {
    if (!executeRecaptcha) {
      return {
        success: false,
        error: 'reCAPTCHA no está disponible'
      };
    }

    try {
      console.log('🔒 Executing reCAPTCHA with action:', action);
      
      // Ejecutar reCAPTCHA para obtener el token
      const token = await executeRecaptcha(action);
      console.log('reCAPTCHA token generado:', token);
      console.log('Action used:', action);
      
      if (!token) {
        return {
          success: false,
          error: 'No se pudo generar el token de reCAPTCHA'
        };
      }

      // Validar el token con el backend
      console.log('Validando token con el backend...');
      try {
        const validationResult = await validateRecaptcha(token, action, minScore);
        
        if (validationResult.success) {
          return {
            success: true,
            token: token,
            score: validationResult.score,
            action: validationResult.action
          };
        } else {
          return {
            success: false,
            error: 'Validación de reCAPTCHA fallida',
            score: validationResult.score,
            error_codes: validationResult.error_codes
          };
        }
      } catch (backendError) {
        console.warn('Backend reCAPTCHA validation failed, proceeding anyway:', backendError);
        // Si el backend falla, continuamos con el token para no bloquear al usuario
        return {
          success: true,
          token: token,
          score: 0.8, // Puntuación asumida
          warning: 'Validación de backend omitida por error del servidor'
        };
      }
    } catch (error) {
      console.error('Error en reCAPTCHA:', error);
      return {
        success: false,
        error: 'Error en la verificación de reCAPTCHA: ' + error.message
      };
    }
  };

  return {
    executeAndValidate,
    isAvailable: !!executeRecaptcha
  };
};
